var defaultTemplates = {
  labelText: '{{name}}'
};
export default defaultTemplates;